import React, {Component} from 'react';

//import { createStackNavigator } from 'react-navigation-stack';
//import { createAppContainer } from 'react-navigation';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';


import { cf } from './src/c_20210427a_YSh/cf';
import { ce } from './src/c_20210427a_YSh/ce';
import { iv } from './src/c_20210427a_YSh/iv';
import { ic } from './src/c_20210427a_YSh/ic';
import { bf } from './src/c_20210427a_YSh/bf';
import { cp } from './src/c_20210427a_YSh/cp';
import { ip } from './src/c_20210427a_YSh/ip';

import cLgn from './src/c_20210427a_YSh/cLgn';
import iHome from './src/c_20210427a_YSh/iHome';
//import iOwnHome from './src/c_20210427a_YSh/iOwnHome';
//import iAdmHome from './src/c_20210427a_YSh/iAdmHome';
//import iMmbHome from './src/c_20210427a_YSh/iMmbHome';
import iCpyList from './src/c_20210427a_YSh/iCpyList';
import iCpyDtl from './src/c_20210427a_YSh/iCpyDtl';

import iUserList from './src/c_20210427a_YSh/iUserList';
import iUserDtl from './src/c_20210427a_YSh/iUserDtl';
//import iOwnDtl from './src/c_20210427a_YSh/iOwnDtl';
//import iAdmDtl from './src/c_20210427a_YSh/iAdmDtl';
//import iMmbDtl from './src/c_20210427a_YSh/iMmbDtl';

import iMngList from './src/iMngList';
import iMngDtl from './src/iMngDtl';
import iMngInp from './src/iMngInp';

//import iChkList from './src/iChkList';
import iPrcList from './src/iPrcList';
import iPrcDtl from './src/iPrcDtl';
//import iPrcInp from './src/iPrcInp';

//import cMsgList from './src/c_20210427a_YSh/cMsgList';
import iMsgList from './src/c_20210427a_YSh/iMsgList';
import iMsgSet from './src/c_20210427a_YSh/iMsgSet';
import iMsgDtl from './src/c_20210427a_YSh/iMsgDtl';

import iOrgList from './src/c_20210427a_YSh/iOrgList';
import iOrgDtl from './src/c_20210427a_YSh/iOrgDtl';

const config = {
  screens: {
  }
};

const linking = {
  prefixes: [ic.g_url0],
//    config,
};

/*
const _stack = createStackNavigator(
    ic.gdd_srnss,
    {
      initialRouteName: ic.g_iniPageName,
      mode: 'modal', // modal
      defaultNavigationOptions: {
        headerShown: false, // header を不使用
        animationEnabled: false, // animation を不使用
      }
    },
);
const AppContainer = createAppContainer(_stack)

export default class App extends React.Component {

  render() {
    return (
      <AppContainer />
    );
  };
};
*/

const Stack = createStackNavigator();

//function App() {
export default function App() {

  // NavigationContainer に linking を指定すると url に query parameters が 表示される模様
  return (
    <NavigationContainer
    >
      <Stack.Navigator
          initialRouteName='cLgn'
      >
        <Stack.Screen
          name='cLgn'
          component={cLgn}
          initialParams={{}}
          options={{
            title: 'ログイン',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iHome'
          component={iHome}
          initialParams={{}}
          options={{
            title: 'ホーム',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iCpyList'
          component={iCpyList}
          initialParams={{}}
          options={{
            title: '法人一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iCpyDtl'
          component={iCpyDtl}
          initialParams={{}}
          options={{
            title: '法人情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iUserList'
          component={iUserList}
          initialParams={{}}
          options={{
            title: '利用者一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iUserDtl'
          component={iUserDtl}
          initialParams={{}}
          options={{
            title: '利用者情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iPrcList'
          component={iPrcList}
          initialParams={{}}
          options={{
            title: '業務プロセス一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iPrcDtl'
          component={iPrcDtl}
          initialParams={{}}
          options={{
            title: '業務プロセス情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMngList'
          component={iMngList}
          initialParams={{}}
          options={{
            title: 'チェックシート一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMngDtl'
          component={iMngDtl}
          initialParams={{}}
          options={{
            title: 'チェックシート設定情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMngInp'
          component={iMngInp}
          initialParams={{}}
          options={{
            title: 'チェックシート回答情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMsgList'
          component={iMsgList}
          initialParams={{}}
          options={{
            title: 'メッセージグループ一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMsgSet'
          component={iMsgSet}
          initialParams={{}}
          options={{
            title: 'メッセージ設定',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iMsgDtl'
          component={iMsgDtl}
          initialParams={{}}
          options={{
            title: 'メッセージ情報',
            headerShown: false, 
//            headerShown: true, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iOrgList'
          component={iOrgList}
          initialParams={{}}
          options={{
            title: '部門一覧',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
        <Stack.Screen
          name='iOrgDtl'
          component={iOrgDtl}
          initialParams={{}}
          options={{
            title: '部門情報',
            headerShown: false, 
            animationEnabled: false,
          }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );

};
